<template>
  <mdb-modal :size="size" :show="show" @close="$emit('close')">
    <mdb-modal-header>
      <mdb-modal-title class="sub-title">
        <mdb-icon :icon="icon"/> {{title}}</mdb-modal-title>
    </mdb-modal-header>
    <mdb-modal-body style="font-size:15px">
      <slot/>
    </mdb-modal-body>
  </mdb-modal>
</template>
<script>
import { mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter } from 'mdbvue';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
export default {
  name: 'ModalDlg',
  components: { mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody },
  props: ['size', 'show', 'title', 'icon']
}
</script>
